export const styles = (theme) => {
    return {
        app: {
            // height: '100vw'
        }
    }
}